module.exports = __webpack_public_path__ + "static/media/smallRabbit_300-200.d01ad493.png";